export const WebsiteName: string = "Ace The Round"
export const WebsiteBaseUrl: string = "https://acetheround.com"
export const WebsiteDescription: string =
  "Prepare for your dream finance job with our AI-powered interview training platform"
export const CreateProfileStep: boolean = true
